export enum TILE_CUSTOMIZATION {
  MATERIAL = 'material',
  FRAME_COLOR = 'frameColor',
  SIZE = 'tileSize',
  FILTER = 'filter',
  MATTING_COLOR = 'mattingColor',
  MATTING = 'matting',
  LAYOUT = 'layout',
  COLLAGE_TEXT = 'collageText',
}

export const URL_PARAM_KEYS = {
  MATERIAL: 'material',
  FRAME_COLOR: 'color',
  SIZE: 'size',
} as const

export function getCustomizationDisplayKey(customization: TILE_CUSTOMIZATION) {
  switch (customization) {
    case TILE_CUSTOMIZATION.MATERIAL:
      return 'material'
    case TILE_CUSTOMIZATION.FRAME_COLOR:
      return 'frame'
    case TILE_CUSTOMIZATION.SIZE:
      return 'size'
    case TILE_CUSTOMIZATION.FILTER:
      return 'effect'
    case TILE_CUSTOMIZATION.MATTING_COLOR:
      return 'border'
    case TILE_CUSTOMIZATION.MATTING:
      return 'border'
    case TILE_CUSTOMIZATION.LAYOUT:
      return 'layout'
    case TILE_CUSTOMIZATION.COLLAGE_TEXT:
      return 'text'
  }
}
